<!-- Splash mientras carga -->
<div class="cc-splash" *ngIf="!ready">
  <div class="cc-splash__icon-wrap">
    <mat-icon>inventory_2</mat-icon>
  </div>
  <div class="cc-splash__dots"><span></span><span></span><span></span></div>
  <p class="cc-splash__text">Cargando concepto…</p>
</div>

<ng-container *ngIf="ready">

  <!-- Header -->
  <div class="cc-header">
    <div class="cc-header__left">
      <div class="cc-header__icon">
        <mat-icon>{{ concept.uid ? 'edit' : 'add_box' }}</mat-icon>
      </div>
      <div>
        <h2 class="cc-header__title">
          {{ concept.uid ? 'Editar concepto' : 'Nuevo concepto' }}
        </h2>
        <p class="cc-header__sub">Producto / Servicio</p>
      </div>
    </div>
    <div class="cc-header__actions">
      <button *ngIf="!example" mat-stroked-button class="cc-btn-example" (click)="showTemplate()">
        <mat-icon>visibility</mat-icon> Ver ejemplo
      </button>
      <button *ngIf="!example" mat-flat-button class="cc-btn-save" [disabled]="saving" (click)="onSubmit()">
        <mat-icon>save</mat-icon> {{ saving ? 'Guardando…' : 'Guardar' }}
      </button>
      <button mat-icon-button class="cc-btn-close" (click)="closeDialog()" matTooltip="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Contenido con scroll -->
  <mat-dialog-content class="cc-content">

    <div class="row g-3">

      <!-- Columna izquierda: datos generales -->
      <div class="col-12 col-md-6">

        <app-input inputType="text" placeholder="Nombre *" name="concept.name" [isRequired]="true"
          [(ngModel)]="concept.name" [ngModelOptions]="{standalone: true}"></app-input>

        <app-input inputType="text" placeholder="Descripción / Características" name="concept.description"
          [(ngModel)]="concept.description" [ngModelOptions]="{standalone: true}"></app-input>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Código de barras</mat-label>
          <input type="text" matInput name="concept.barcode" [(ngModel)]="concept.barcode"
            [ngModelOptions]="{standalone: true}" [readonly]="readOnly"
            (ngModelChange)="renderBarcode($event)">
        </mat-form-field>

        <div id="barcodeContainer" class="cc-barcode-preview"
          [hidden]="!concept.barcode || barcodeInvalid || barcodeRenderError">
          <svg #barcodePreview></svg>
        </div>
        <p class="cc-barcode-error" *ngIf="barcodeInvalid && concept.barcode">
          <mat-icon>warning</mat-icon> Código inválido para CODE128
        </p>
        <p class="cc-barcode-error" *ngIf="barcodeRenderError && concept.barcode">
          <mat-icon>warning</mat-icon> No se pudo generar el código de barras.
          <a href="javascript:void(0)" (click)="renderBarcode(concept.barcode)">Reintentar</a>
        </p>

        <div class="row g-2">
          <div class="col-12 col-md-6">
            <app-autocomplete-select [items]="families" [(selectedItemId)]="concept.categoryUid"
              [idField]="'uid'" [displayField]="'name'" placeholder="Familia / Tipo">
            </app-autocomplete-select>
          </div>
          <div class="col-12 col-md-6" *ngIf="providers?.length">
            <app-autocomplete-select [items]="providers" [idField]="'uid'" [displayField]="'companyName'"
              placeholder="Proveedor" (selectionChanged)="addProviderUid($event)">
            </app-autocomplete-select>
            <div class="cc-chips mt-1">
              <span *ngFor="let uid of relation; trackBy: trackByIndex" class="cc-chip">
                {{ getProviderName(uid) }}
                <button type="button" class="cc-chip__remove" (click)="removeProvider(uid)">×</button>
              </span>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <app-autocomplete-select [items]="accountsAndTaxes.taxes" [idField]="'id'" [displayField]="'name'"
              placeholder="Impuestos" (selectionChanged)="onSelectTax($event)">
            </app-autocomplete-select>
          </div>
          <div class="col-12" *ngIf="concept.taxes?.length > 0">
            <convfact-chips-component [chipsElements]="concept.taxes" [container]="this" [changeFunction]="changeChips">
            </convfact-chips-component>
          </div>
        </div>

      </div>

      <!-- Columna derecha: precios y stock -->
      <div class="col-12 col-md-6">

        <div class="row g-2">
          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Precio Costo</mat-label>
              <input type="text" matInput name="concept.costPrice" [(ngModel)]="concept.costPrice"
                [ngModelOptions]="{standalone: true}" numberDecimalsDirective>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Precio Neto (Base) *</mat-label>
              <input type="text" matInput name="concept.netPrice" [(ngModel)]="concept.netPrice"
                [ngModelOptions]="{standalone: true}" required numberDecimalsDirective>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descuento (%)</mat-label>
              <input type="text" matInput name="concept.discount" [(ngModel)]="concept.discount"
                [ngModelOptions]="{standalone: true}" numberDecimalsDirective>
            </mat-form-field>
          </div>
          <div class="col-6">
            <app-input inputType="text" placeholder="Atajo / Ref. interna" name="concept.shortcut"
              [(ngModel)]="concept.shortcut" [ngModelOptions]="{standalone: true}"></app-input>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Precio Total *</mat-label>
              <input type="text" matInput name="concept.price" [(ngModel)]="concept.price"
                [ngModelOptions]="{standalone: true}" required numberDecimalsDirective>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Unidades</mat-label>
              <input type="text" matInput name="concept.units" [(ngModel)]="concept.units"
                [ngModelOptions]="{standalone: true}" numberDecimalsDirective>
            </mat-form-field>
          </div>
          <div class="col-6">
            <app-input inputType="text" placeholder="Talla" name="concept.size"
              [(ngModel)]="concept.size" [ngModelOptions]="{standalone: true}"></app-input>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Límite stock (alarma)</mat-label>
              <input type="text" matInput name="concept.limitUnits" [(ngModel)]="concept.limitUnits"
                [ngModelOptions]="{standalone: true}" numberDecimalsDirective>
            </mat-form-field>
          </div>
          <div class="col-6">
            <app-input inputType="text" placeholder="Modelo" name="concept.model"
              [(ngModel)]="concept.model" [ngModelOptions]="{standalone: true}"></app-input>
          </div>
        </div>

        <div class="cc-toggles">
          <mat-slide-toggle (change)="setValueStockControl($event)" [checked]="concept.isStockEnabled">
            Control de stock <app-help key='Conceptos7'></app-help>
          </mat-slide-toggle>
          <mat-slide-toggle (change)="setValueSerialNumbers($event)" [checked]="concept.serialNumber">
            Número de serie
          </mat-slide-toggle>
          <mat-slide-toggle (change)="setValueIsTpv($event)" [checked]="concept.isTpv">
            Mostrar en TPV <app-help key='ConceptosTpv'></app-help>
          </mat-slide-toggle>
        </div>

      </div>
    </div>

    <!-- Resumen de cálculo -->
    <div class="cc-summary">
      <p class="cc-summary__label">Resumen</p>
      <div class="cc-summary__row">
        <span>Descuento</span><strong>{{ concept.discount }}%</strong>
      </div>
      <div class="cc-summary__row">
        <span>Subtotal</span><strong>{{ calcularSubtotal() }}</strong>
      </div>
      <div class="cc-summary__row" *ngFor="let taxView of taxesView; trackBy: trackByIndex">
        <span>{{ taxView }}</span>
      </div>
      <div class="cc-summary__row cc-summary__row--total">
        <span>Total</span><strong>{{ calcularTotal() }}</strong>
      </div>
    </div>

    <!-- Imagen y fichero adjunto -->
    <div class="cc-section-label">
      <mat-icon>attach_file</mat-icon> Archivos adjuntos
    </div>

    <div class="row g-3">
      <!-- Imagen -->
      <div class="col-12 col-md-6">
        <p class="cc-attach-label">Imagen</p>
        <ng-container *ngIf="pendingImagePreview; else savedImage">
          <img [src]="pendingImagePreview" class="cc-attach-img" alt="Vista previa de la imagen" />
          <p class="cc-attach-hint">{{ pendingImage?.name }} · se guardará al pulsar Guardar</p>
        </ng-container>
        <ng-template #savedImage>
          <ng-container *ngIf="concept.imageId != 0">
            <div class="cc-attach-loading" *ngIf="!imageReady">
              <div class="cc-splash__dots"><span></span><span></span><span></span></div>
              <p class="cc-splash__text">Cargando imagen…</p>
            </div>
            <ng-container *ngIf="imageReady">
              <iframe [src]="imgdUrlFile" class="cc-attach-iframe" type="application/pdf"></iframe>
            </ng-container>
          </ng-container>
        </ng-template>
        <div class="cc-attach-actions">
          <label class="cc-file-label">
            <mat-icon>file_upload</mat-icon> {{ pendingImage || concept.imageId != 0 ? 'Cambiar imagen' : 'Seleccionar imagen' }}
            <input type="file" hidden accept="image/*" (change)="upload($event, 'image')" />
          </label>
          <button *ngIf="pendingImage" mat-stroked-button type="button" (click)="clearPendingImage()">
            <mat-icon>close</mat-icon> Descartar
          </button>
          <button *ngIf="!pendingImage && concept.imageId != 0" mat-stroked-button color="warn" (click)="deleteFile(false, true)">
            <mat-icon>delete</mat-icon> Eliminar
          </button>
        </div>
      </div>

      <!-- Fichero -->
      <div class="col-12 col-md-6">
        <p class="cc-attach-label">Fichero</p>
        <ng-container *ngIf="pendingFilePreview; else savedFile">
          <iframe [src]="pendingFilePreview" class="cc-attach-iframe" type="application/pdf"></iframe>
          <p class="cc-attach-hint">{{ pendingFile?.name }} · se guardará al pulsar Guardar</p>
        </ng-container>
        <ng-template #savedFile>
          <ng-container *ngIf="concept.fileId != 0">
            <div class="cc-attach-loading" *ngIf="!fileReady">
              <div class="cc-splash__dots"><span></span><span></span><span></span></div>
              <p class="cc-splash__text">Cargando fichero…</p>
            </div>
            <ng-container *ngIf="fileReady">
              <iframe [src]="sanitizedUrlFile" class="cc-attach-iframe" type="application/pdf"></iframe>
            </ng-container>
          </ng-container>
        </ng-template>
        <div class="cc-attach-actions">
          <label class="cc-file-label">
            <mat-icon>file_upload</mat-icon> {{ pendingFile || concept.fileId != 0 ? 'Cambiar fichero' : 'Seleccionar fichero' }}
            <input type="file" hidden accept=".pdf,application/pdf" (change)="upload($event, 'file')" />
          </label>
          <button *ngIf="pendingFile" mat-stroked-button type="button" (click)="clearPendingFile()">
            <mat-icon>close</mat-icon> Descartar
          </button>
          <button *ngIf="!pendingFile && concept.fileId != 0" mat-stroked-button color="warn" (click)="deleteFile(true, false)">
            <mat-icon>delete</mat-icon> Eliminar
          </button>
        </div>
      </div>
    </div>

  </mat-dialog-content>

</ng-container>
